<div>
  <div class="row">
    <div class="col title-col">
      <mat-icon svgIcon="suitcase-job-history-clock"></mat-icon>
      <h1>{{ ("pastJobs" | i18n) || "Vergangene Dienste" }}</h1>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col log-entry-text">
      {{ ("pastThreeMonthsDescription" | i18n) || "in den letzten 3 Monaten" }}
    </div>
  </div>
  <ng-container *ngIf="!isLoading; else loadingTemplate">
    <div class="row mb-1">
      <div class="col log-large-text">
        <span class="log-entry-highlight">{{ countInDepartment }}</span>
        {{ ("in" | i18n) || "bei" }}
        <span class="log-entry-highlight">{{ departmentName }}</span>
        {{ ("worked" | i18n) || "gearbeitet" }}.
      </div>
    </div>
    <div class="row mb-3">
      <div class="col log-large-text">
        <span class="log-entry-secondary-highlight">{{
          countInOrganisation
        }}</span>
        {{ ("in" | i18n) || "bei" }}
        <span class="log-entry-secondary-highlight">{{
          organisation?.name
        }}</span>
        {{ ("worked" | i18n) || "gearbeitet" }}.
      </div>
    </div>
    <div class="spacer-bar mb-1"></div>
    <div class="row">
      <div class="col">
        <div
          class="py-2"
          *ngFor="let job of recentJobs">
          <div class="row mb-1">
            <div class="col date-col">
              <div class="log-entry-date">{{ job.date | date }}</div>
              <ng-container *ngFor="let shift of job.shifts">
                <mat-chip>
                  {{
                    ("shifts." + shift.shift | i18n) || shift.shift
                  }}</mat-chip
                >
                <div class="log-entry-date">
                  {{ shift.from | time }} - {{ shift.to | time }}
                </div>
              </ng-container>
            </div>
          </div>
          <div class="row">
            <div class="col log-entry-organisation-name">
              <span
                [class.log-entry-highlight]="
                  job.department.id === data.departmentId
                "
                >{{ job.department.displayName }}</span
              >
              {{ organisation?.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spacer-bar"></div>
    <div class="row mb-3">
      <div class="col log-entry-text">
        <div>
          {{
            ("moreThanThreeMonthsDescription" | i18n) ||
              "vor mehr als 3 Monaten"
          }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div
          class="py-2"
          *ngFor="let job of oldJobs">
          <div class="row mb-1">
            <div class="col date-col">
              <div
                class="log-entry-date"
                *ngIf="job.date">
                {{ job.date | date }}
              </div>
              <ng-container *ngFor="let shift of job.shifts">
                <mat-chip>
                  {{
                    ("shifts." + shift.shift | i18n) || shift.shift
                  }}</mat-chip
                >
                <div class="log-entry-date">
                  {{ shift.from | time }} - {{ shift.to | time }}
                </div>
              </ng-container>
            </div>
          </div>
          <div class="row">
            <div class="col log-entry-organisation-name">
              <span>{{ job.department.displayName }}</span>
              {{ organisation?.name }}
            </div>
          </div>
        </div>
        <div *ngIf="oldJobs.length === 0">
          <div class="row">
            <div class="col log-large-text">
              {{ ("noPastJobs" | i18n) || "Keine vergangenen Dienste" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loadingTemplate>
  <div class="d-flex align-items-center justify-content-center">
    <mat-spinner diameter="24"></mat-spinner>
  </div>
</ng-template>
